import { gql } from '@apollo/client'

export const GET_ARTIST_PRODUCTS = gql`
  query ($artist_id: String!, $name: String!) {
    getArtistProducts(artist_id: $artist_id, name: $name) {
      id
      name
      gps_status
      configuration
      locals {
        id
        label_id
        campaign_id
      }
    }
  }
`
